export default __webpack_public_path__ + "static/media/lofty.06117b55.jpg";